var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('li',{staticClass:"item",on:{"click":_vm.onClick}},[_c('div',{class:['title', _vm.color]},[_c('span',[_vm._t("default")],2),_c('Icon',{attrs:{"name":"chevron-right","width":"24","height":"24"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }